import React, { useState } from "react";
import { Row, Col, Form, Input, Button, Modal, Select, Skeleton, InputNumber } from "antd";
import { gql, useMutation } from "@apollo/client";
import UploadFile from "@general/UploadFile";
const AddMTPackage = ({ services, loading }) => {
  const CREATEPACKAGE = gql`
    mutation createMRPackage($createMRPackageInput: CreateMRPackageInput!) {
      createMRPackage(createMRPackageInput: $createMRPackageInput) {
        id
        name
      }
    }
  `;
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const [runCreatePackage, createPackage] = useMutation(CREATEPACKAGE, {
    onCompleted({ createMRPackage }) {
      Modal.success({
        content: `${createMRPackage?.name} به پکیج های صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  const doCreatePackage = (createMRPackageInput) => {
    runCreatePackage({
      variables: {
        createMRPackageInput,
      },
    });
  };


  if (loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Form layout="vertical" onFinish={doCreatePackage} form={form}>
        <Row gutter={15}>
          <Col xs={24} lg={12}>
            <Row gutter={15}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="نام پکیج"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام پکیج را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="نام پکیج" />
                </Form.Item>

                <Form.Item
                  name="amountRial"
                  label="هزینه (ریال)"
                  rules={[
                    {
                      required: true,
                      message: "لطفا هزینه را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا هزینه را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"هزینه"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
               
                <Form.Item
                  name="sessions"
                  label="تعداد جلسات"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تعداد جلسات را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا تعداد جلسات را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"تعداد جلسات"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="productId"
                  id="productId"
                  label="خدمت"
                  rules={[
                    {
                      required: true,
                      message: "لطفا خدمت مورد نظر را انتخاب کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Select
                    showSearch
                    allowClear
                    listHeight={200}
                    style={{
                      width: 200,
                    }}
                    placeholder={"نوع خدمت"}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={services}
                  />
                </Form.Item>
                <Form.Item
                  name="strikethroughRial"
                  label="قیمت خط خورده (ریال)"
                  rules={[
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا قیمت را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"قیمت خط خورده"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  name="image"
                  label="پوستر"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر پکیج آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile />
                </Form.Item>
              </Col>
            </Row>
            <Row>
            
            </Row><Row>
              <Col span={24}>
                <Form.Item label="توضیحات" name="description">
                  <Input.TextArea rows={2} placeholder="توضیحات" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Button
          type="primary"
          htmlType="submit"
          loading={createPackage.loading && true}
        >
          ثبت پکیج
        </Button>
      </Form>
    </>
  );
};

export default AddMTPackage;
